// extracted by mini-css-extract-plugin
module.exports = {"root":"options_root__1dVGl","label":"options_label__3NBVs","space":"options_space__2yi-3"};